import { render, staticRenderFns } from "./CreateTreatmentModal.vue?vue&type=template&id=2ee63b59"
import script from "./CreateTreatmentModal.vue?vue&type=script&lang=js"
export * from "./CreateTreatmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports